import { useSnackbar } from 'notistack';
import IconButton from "@mui/material/IconButton";
import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as CancelOutlinedIcon } from '../assets/icons/main/close-circle-icon.svg';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/material';
import {palette} from '../theme/palette';

const useNotification = () => {
    const dispatch = useDispatch();
    const [conf, setConf] = useState<any>({});
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const snackBarKey = Date.now();
    const theme:any = useTheme();
    const action = () => (
        <Fragment>
            <IconButton onClick={() => { closeSnackbar(snackBarKey) }}>
              <CancelOutlinedIcon style={{ color: palette.primary.contrastText }} />
            </IconButton>
        </Fragment>
    );
    useEffect(() => {
        if (conf?.msg) {
            enqueueSnackbar(conf.msg, {
                key: (conf.snackBarKey) ? conf.snackBarKey : snackBarKey,
                variant: (conf.variant) ? conf.variant : 'info',
                autoHideDuration: (conf.duration) ? conf.duration : 3000,
                action: (conf?.action) ? conf?.action : action,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
            if (conf?.dispatchAction) {
                dispatch(conf.dispatchAction)
            }
        }
    }, [conf]);
    return [conf, setConf];
};

export default useNotification;